// 9fbef606107a605d69c0edbcd8029e5d
import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Image from '@tcp/core/src/components/common/atoms/Image';
import RecommendationSkeleton from '@tcp/core/src/components/common/molecules/Recommendations/views/RecommendationSkeleton.view';
import OutfitBreadcrumbs from '@tcp/core/src/components/features/browse/OutfitDetails/molecules/OutfitBreadcrumbs/OutfitBreadcrumbs';
import { StyledBreadcrumbsContainer } from '@tcp/core/src/components/features/browse/OutfitDetails/styles/OutfitDetailsNew.style';
import withStyles from '../../../../../../common/hoc/withStyles';
import LoaderSkelton from '../../../../../../common/molecules/LoaderSkelton';
import styles, {
  StyledPaginatedGridSkeleton,
  StyledOutfitCarouselSkeleton,
} from '../styles/OutfitProductSkeleton.style';
import {
  StyledRecommendationsContainer,
  StyledOutfitList,
} from '../../../styles/OutfitDetailsNew.style';

const ProductOverViewDetailWrapper = () => {
  return (
    <div className="product-overview-wrapper">
      <div className="product-overview-detail-wrapper">
        <div className="product-image">
          <LoaderSkelton />
        </div>
        <div className="product-title-price-wrapper">
          <div className="product-title">
            <LoaderSkelton />
          </div>
          <div className="product-price">
            <LoaderSkelton />
          </div>
          <div className="hide-on-mobile hide-on-tablet">
            <div className="product-color">
              <LoaderSkelton />
            </div>
            <div className="product-size">
              <LoaderSkelton />
            </div>
          </div>
        </div>
      </div>
      <div className="hide-on-desktop">
        <div className="product-color">
          <LoaderSkelton />
        </div>
        <div className="product-size">
          <LoaderSkelton />
        </div>
      </div>
      <div className="product-add-to-bag">
        <LoaderSkelton />
      </div>
    </div>
  );
};

const OutFitProductGridComponent = (productLength) => {
  return (
    <StyledOutfitList className="products-list-grid grid-product-skelton-view">
      {[...Array(productLength)].map((id) => (
        <li key={id} className="product-list-item">
          <StyledPaginatedGridSkeleton>
            <LoaderSkelton className="grid-image-skeleton" />
            <div className="grid-price-skeleton">
              <LoaderSkelton width="100px" />
              <LoaderSkelton width="32px" />
            </div>

            <LoaderSkelton className="grid-promo-skeleton" />
            <LoaderSkelton className="grid-title-skeleton" />
          </StyledPaginatedGridSkeleton>
        </li>
      ))}
    </StyledOutfitList>
  );
};

const OutfitProductSkeleton = ({
  className,
  isOutfitsRedesign,
  styliticsProductTabList,
  selectedOutfitId,
  outfitIdLocal,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const outfitArray = styliticsProductTabList && styliticsProductTabList[selectedOutfitId];

  const findCurrentOutfitDetails = useMemo(() => {
    if (outfitArray && Array.isArray(outfitArray) && outfitIdLocal) {
      return outfitArray.find((item) => item?.id === parseInt(outfitIdLocal, 10));
    }
    return {};
  }, [outfitArray, outfitIdLocal]);

  const getImageComponent = (currentOutFitDetails) => {
    return !isOutfitsRedesign ? (
      <Col
        colSize={{ small: 6, medium: 3, large: 6 }}
        ignoreGutter={{ small: true }}
        className="outfit-image"
      >
        <Image className="promo-area-0" src={currentOutFitDetails.largeImageUrl} />
      </Col>
    ) : (
      <StyledOutfitCarouselSkeleton>
        <Image className="promo-area-0" src={currentOutFitDetails.largeImageUrl} />
      </StyledOutfitCarouselSkeleton>
    );
  };
  useEffect(() => {
    if (window) window.scrollTo(0, 0);
  }, []);

  const currentOutFitDetails = findCurrentOutfitDetails;
  if (!currentOutFitDetails) return <></>;
  return (
    <div className={className}>
      <StyledBreadcrumbsContainer>
        <OutfitBreadcrumbs selectedProductId={selectedOutfitId} />
      </StyledBreadcrumbsContainer>
      <Row fullBleed className="product-detail-skeleton-wrapper">
        {currentOutFitDetails && currentOutFitDetails.largeImageUrl ? (
          getImageComponent(currentOutFitDetails)
        ) : (
          <Col colSize={{ small: 6, medium: 8, large: 6 }} className="product-price-col">
            <div className="product-main-image">
              <LoaderSkelton />
            </div>
          </Col>
        )}
        {isOutfitsRedesign ? (
          <>
            {currentOutFitDetails &&
            currentOutFitDetails.items &&
            Array.isArray(currentOutFitDetails.items) &&
            currentOutFitDetails.items.length > 0
              ? OutFitProductGridComponent(currentOutFitDetails?.items.length)
              : OutFitProductGridComponent(4)}
          </>
        ) : (
          <Col colSize={{ small: 6, medium: 5, large: 6 }} className="product-price-col">
            <div className="product-overview-wrapper-main">
              {currentOutFitDetails &&
              currentOutFitDetails.items &&
              Array.isArray(currentOutFitDetails.items) &&
              currentOutFitDetails.items.length > 0 ? (
                currentOutFitDetails?.items.map((d) => <ProductOverViewDetailWrapper key={d} />)
              ) : (
                <>
                  <ProductOverViewDetailWrapper />
                  <ProductOverViewDetailWrapper />
                </>
              )}
            </div>
          </Col>
        )}
      </Row>
      <StyledRecommendationsContainer>
        <RecommendationSkeleton variations="moduleO" isOutFitPage />
        <RecommendationSkeleton variations="moduleO" isOutFitPage />
      </StyledRecommendationsContainer>
    </div>
  );
};

OutfitProductSkeleton.propTypes = {
  className: PropTypes.string.isRequired,
  selectedOutfitId: PropTypes.string,
};

export default withStyles(OutfitProductSkeleton, styles);
export { OutfitProductSkeleton as OutfitProductSkeletonVanilla };
